export enum AVATAR_SIZES {
  SMALL = 'SMALL',
  MEDIUM = 'MEDIUM',
  LARGE = 'LARGE',
  OVERSIZED = 'OVERSIZED',
}

export enum AVATAR_SHAPES {
  CIRCLE = 'CIRCLE',
  SQUARE = 'SQUARE',
}

export enum AVATAR_CONNECTION_STATUS {
  ONLINE = 'ONLINE',
  OFFLINE = 'OFFLINE',
}
